import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { Header } from '@/models/dataSource';

const columnHelper = createColumnHelper<Record<string, any>>();

interface GetFileElementsTableColumnsParams {
  t: TFunction;
  headers: Header[];
  fileContent: string[][];
  isDefaultHeaderCorrect: boolean;
}

export const getFileElementsTableColumns = ({
  t,
  headers,
  fileContent,
  isDefaultHeaderCorrect,
}: GetFileElementsTableColumnsParams): ColumnDef<Record<string, any>>[] => {
  const retrieveHeaderName = (index: number) => {
    return isDefaultHeaderCorrect ? fileContent[0]?.[index] : `${t('data_source_edit:file.header.column')} ${index + 1}`;
  };

  const retrieveHeaderMapping = (header: Header) => {
    return header.skip ? t('data_source_edit:file.header.ignored') : header.displayName;
  };

  return [
    columnHelper.accessor('event_index', {
      id: 'event_index',
      header: () => t('ALL:data_sources.eventId'),
      cell: ({ row }) => <p className='text-xs text-tertiary-600'>{row.index + 1}</p>,
      sortingFn: (row) => row.index + 1,
      minSize: 75,
      maxSize: 75,
    }),
    ...headers.map((header, index) =>
      columnHelper.accessor(`col_${index}`, {
        id: `col_${index}`,
        header: () => `${retrieveHeaderName(index)} - ${retrieveHeaderMapping(header)}`,
        cell: ({ getValue }) => <p className='truncate text-xs text-tertiary-600'>{getValue() as string}</p>,
        minSize: 130,
        maxSize: 130,
      })
    ),
  ];
};
